// extracted by mini-css-extract-plugin
export default {"subsectionTitleLabel":"HypertensionBasicCareComponent_subsectionTitleLabel__x7JRT","dataBlockWrapper":"HypertensionBasicCareComponent_dataBlockWrapper__q-lHg"};